import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import "./i18n";
import "./utils/yupLocale";
import { Provider } from "react-redux";

import store from "./store";

/*
 * Modal açılınca header'ın sağa kaymasını engeller.
 *
 * reactstrap bir modal açarken body'ye `modal-open` sınıfı (overflow: hidden)
 * verip sayfa scrollbar'ını gizler ve kayan içeriği telafi etmek için body'ye
 * scrollbar genişliği kadar inline `padding-right` yazar. #page-topbar ise
 * `position: fixed` — body kutusuna değil viewport'a çakılı, dolayısıyla o
 * telafiden hiç etkilenmez: scrollbar kaybolunca viewport genişler ve header'ın
 * sağa dayalı öğeleri zıplar.
 *
 * Burada body'ye yazılan telafi bir CSS değişkenine aynalanır; header'ı
 * pedleyen kural custom.css'te. Sabit bir ölçüm yerine AYNALAMA yapılıyor
 * çünkü reactstrap body'yi yalnız sayfada gerçekten scrollbar varken pedliyor —
 * kısa sayfada hiçbir şey kaymıyor ve sabit bir değer header'ı ters yöne
 * kaydırırdı. Değişken yerine header'a doğrudan inline stil yazmak da React'in
 * yeniden render'ında ezilebilirdi.
 */
const observeModalScrollbar = () => {
  const sync = () =>
    document.documentElement.style.setProperty(
      "--app-scrollbar-width",
      document.body.style.paddingRight || "0px"
    );
  new MutationObserver(sync).observe(document.body, {
    attributes: true,
    attributeFilter: ["class", "style"],
  });
  sync();
};
observeModalScrollbar();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <React.Fragment>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.Fragment>
  </Provider>
);
